import React from 'react';
import { Card } from '@avila-tek/ui/src';
import { ShopCart, TTotal, ShopCartItem } from '../../../models';
import { TEditShopCartInput } from '../../../hooks';
import ShopcartItem from './ShopcartItem';
import ShopcartTotal from './ShopcartTotal';
import LoadingShopCart from './LoadingShopCart';

interface ShopcartSummaryProps {
  total: TTotal;
  productsShopItems: ShopCartItem[];
  benefitsShopItems: ShopCartItem[];
  plansShopItems: ShopCartItem[];
  editShopCart: (input: TEditShopCartInput) => void;
  shopCart: ShopCart;
  loading: boolean;
}

function ShopcartSummary({
  productsShopItems,
  benefitsShopItems,
  plansShopItems,
  shopCart,
  total,
  editShopCart,
  loading,
}: ShopcartSummaryProps) {
  const getVariantTitle = (variantId: string) => {
    const variant = shopCart.products.find((p) => p.variant._id === variantId);
    return `${variant?.option?.option1 ?? ''} ${
      variant?.option?.option2 ?? ''
    } ${variant?.option?.option3 ?? ''}`;
  };

  const getQuantity = (item: ShopCartItem) =>
    item.shopList.reduce((acc, cur) => acc + cur.quantity, 0);

  return (
    <div className="w-full">
      <Card className="p-4 px-6 relative ">
        {loading ? <LoadingShopCart /> : null}
        <h3 className="text-purple-300 font-semibold text-lg sm:text-xl uppercase my-2">
          Resumen
        </h3>
        <hr />

        {productsShopItems?.length > 0
          ? productsShopItems.map((item, i) => (
              <ShopcartItem
                key={`${item.title}-i`}
                title={item?.title}
                subtitle={getVariantTitle(item[0]?.variant)}
                price={item.price}
                clients={item.shopList}
                editShopCart={editShopCart}
                shopCartItem={item}
                type="product"
                quantity={getQuantity(item)}
              />
            ))
          : null}
        {/* FIXME: el benficio debe traer el fecha de asignacion */}
        {benefitsShopItems?.length > 0
          ? benefitsShopItems.map((item, i) => (
              <ShopcartItem
                key={`${item.title}-${i}`}
                title="Beneficio"
                subtitle={item.title}
                price={item.price}
                clients={item.shopList}
                editShopCart={editShopCart}
                shopCartItem={item}
                type="benefit"
                quantity={getQuantity(item)}
              />
            ))
          : null}

        {plansShopItems?.length > 0
          ? plansShopItems.map((item) => (
              <ShopcartItem
                title="Subscrición"
                subtitle={item?.title}
                price={item.price}
                clients={item.shopList}
                editShopCart={editShopCart}
                shopCartItem={item}
                type="plan"
                quantity={getQuantity(item)}
              />
            ))
          : null}
        <ShopcartTotal total={total} />
      </Card>
    </div>
  );
}

export default ShopcartSummary;
